export function isAdmin(emailOrRole, systemRole) {
	// Check systemRole if passed directly
	if (systemRole === 'admin') {
		return true;
	}
	// Check systemRole from localStorage (set during login)
	try {
		const storedRole = JSON.parse(localStorage.getItem('systemRole'));
		if (storedRole === 'admin') {
			return true;
		}
	} catch (e) {}
	// Fallback: check by email (legacy hardcoded list)
	return [
		'jorgen.rahm@redmanagement.se',
		'par.hammarberg@redmanagement.se',
		'sophie.lofving@redmanagement.se',
		'per.karlsten@redmanagement.se',
		'per.linder@redmanagement.se',
		'magnus.eriksson@redmanagement.se',
	].includes(emailOrRole);
}
